import { Controller } from 'stimulus'
import { googleAnalyticsEvent, googleAnalytics3Event } from 'lib/googleAnalytics'
import isMobile from 'is-mobile'

export default class extends Controller {
  static values = {
    mobilePrompt: Boolean,
    gaEventAction: String,
    gaEventCategory: String,
    url: String,
    itemId: String,
    itemResolution: String,
    downloadContext: String,
    elementsItemId: String
  }

  connect () {
    if (isMobile()) {
      this.mobilePromptValue = true
    } else {
      this.runDownloadProcess()
    }
  }

  runDownloadProcess () {
    this.mobilePromptValue = false

    googleAnalytics3Event({
      eventAction: this.gaEventActionValue,
      eventCategory: this.gaEventCategoryValue,
      eventLabel: this.itemIdValue
    })

    googleAnalyticsEvent({
      eventName: 'download',
      itemId: this.itemIdValue,
      itemResolution: this.itemResolutionValue,
      context: this.downloadContextValue,
      elementsItemId: this.elementsItemIdValue,
      callback: () => {
        this.downloadTheFile()
      }
    })
  }

  downloadTheFile () {
    // This is a function we call to force the browser to download a file.
    // It's in a timeout to allow the browser to render the modal images correctly
    setTimeout(() => {
      window.location.href = this.urlValue
    }, 500)
  }

  getGlobalModalController () {
    return this.application.controllers.find(controller => controller.context.identifier === 'modal')
  }

  closeModal () {
    // Reach out to the existing other global modal controller
    const modalController = this.getGlobalModalController()

    // Hide modal from the screen
    modalController.hideModal()
  }
}
